@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.wrapper {
  padding-bottom: 10px;
  border-bottom: 1px solid @filter-editor--name--border-color;
  font-size: 14px;
}

.header {
  margin-bottom: 20px;
}

.entry-wrapper,
.entry-wrapper-stacked {
  display: flex;
  flex-direction: column;
  > div {
    &:first-of-type {
      font-weight: 500;
      padding-bottom: 5px;
    }
  }
}

.entry-wrapper-stacked {
  margin-top: 10px;
}

.text-area-input {
  width: 100%;
  border: 1px solid @filter-editor--name-input--border-color;
  padding: 4px 10px;
  font-size: 14px;
}

.supplemental {
  margin-top: 20px;
}

.bolded {
  font-weight: 500;
}
